// extracted by mini-css-extract-plugin
module.exports = {"Tit":"PersonalServices_Tit__KIL1r","Title":"PersonalServices_Title__1cwYT","Desc":"PersonalServices_Desc__1BFK8","AddPadding":"PersonalServices_AddPadding__2LgBV"};